<template>
  <StdPageContainer type="list">
    <template slot="title">
      <!-- 标题栏 -->
      <StdPageTitle :title="$t('lang.k_393001')">
        <p class="title_tips">{{ $t('lang.k_393002') }}</p>
      </StdPageTitle>
    </template>
    <!-- 内容区 -->
    <template slot="content">
      <section class="null-data" v-if="list && list.length == 0 && !isSearch">
        <StdNullPage :text="$t('lang.k_393003')" :nullType="'nullData'"></StdNullPage>
      </section>
      <template v-else-if="list">
        <!-- 搜索区域 -->
        <div class="search-area">
          <vh-form :inline="true" :model="searchForm" class="search-form">
            <vh-form-item>
              <vh-input
                round
                v-model="searchForm.target_id"
                :placeholder="$t('lang.k_393004')"
                clearable
                style="width: 130px"
              ></vh-input>
            </vh-form-item>
            <vh-form-item>
              <vh-input
                round
                v-model="searchForm.reporter_contact"
                :placeholder="$t('lang.k_393005')"
                clearable
                style="width: 130px"
              ></vh-input>
            </vh-form-item>
            <vh-form-item>
              <vh-select
                v-model="searchForm.reason_type"
                :placeholder="$t('lang.k_393006')"
                clearable
                round
                style="width: 120px"
              >
                <vh-option
                  v-for="(value, key) in reasonOptions"
                  :key="key"
                  :label="value"
                  :value="key"
                ></vh-option>
              </vh-select>
            </vh-form-item>
            <vh-form-item>
              <vh-select
                v-model="searchForm.status"
                :placeholder="$t('lang.k_393007')"
                clearable
                round
                style="width: 120px"
              >
                <vh-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></vh-option>
              </vh-select>
            </vh-form-item>
            <vh-form-item class="button-group">
              <vh-button round type="primary" @click="handleSearch">
                {{ $t('lang.k_393008') }}
              </vh-button>
              <vh-button round @click="handleExport">{{ $t('lang.k_393009') }}</vh-button>
            </vh-form-item>
          </vh-form>
        </div>

        <!-- 表格区域 -->
        <vh-table
          :data="list"
          class="feedback-list"
          @cell-mouse-enter="handleCellMouseEnter"
          @cell-mouse-leave="handleCellMouseLeave"
        >
          <vh-table-column :label="$t('lang.k_393010')" width="90">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </vh-table-column>
          <vh-table-column
            :label="$t('lang.k_393011')"
            prop="target_id"
            width="120"
          ></vh-table-column>
          <vh-table-column :label="$t('lang.k_393012')" prop="target_name" width="150">
            <template slot-scope="scope">
              <vh-tooltip
                placement="top"
                :disabled="!isTextOverflow"
                :content="scope.row.target_name"
              >
                <div class="activity-name custom-tooltip-content">
                  {{ scope.row.target_name || '- -' }}
                </div>
              </vh-tooltip>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_393013')" width="120">
            <template slot-scope="scope">
              {{ getReasonLabel(scope.row.reason_type) }}
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_393014')" min-width="150">
            <template slot-scope="scope">
              <vh-tooltip
                placement="top"
                :disabled="!isTextOverflow"
                :content="scope.row.reason_desc"
              >
                <div class="description custom-tooltip-content">
                  {{ scope.row.reason_desc || '- -' }}
                </div>
              </vh-tooltip>
            </template>
          </vh-table-column>
          <!-- <vh-table-column label="用户ID" prop="reporter_join_id" width="120"></vh-table-column> -->
          <vh-table-column
            :label="$t('lang.k_393015')"
            prop="reporter_nickname"
            width="150"
          ></vh-table-column>
          <vh-table-column
            :label="$t('lang.k_393016')"
            prop="reporter_contact"
            width="150"
          ></vh-table-column>
          <vh-table-column
            :label="$t('lang.k_393017')"
            prop="created_at"
            width="180"
          ></vh-table-column>
          <vh-table-column :label="$t('lang.k_393018')" width="100">
            <template slot-scope="scope">
              <vh-tag :type="scope.row.status === 3 ? 'success' : 'warning'">
                {{ getStatusLabel(scope.row.status) }}
              </vh-tag>
            </template>
          </vh-table-column>
          <vh-table-column
            :label="$t('lang.k_393019')"
            prop="handled_at"
            width="180"
          ></vh-table-column>
          <vh-table-column :label="$t('lang.k_393020')" width="100" fixed="right">
            <template slot-scope="scope">
              <vh-select
                style="width: 80px"
                :disabled="scope.row.status === 3"
                size="small"
                v-model="scope.row.status"
                @change="handleFeedback(scope.row)"
              >
                <vh-option :label="$t('lang.k_393021')" :value="1"></vh-option>
                <vh-option :label="$t('lang.k_393022')" :value="3"></vh-option>
              </vh-select>
            </template>
          </vh-table-column>
          <template slot="empty">
            <StdNullPage :nullType="'search'"></StdNullPage>
          </template>
        </vh-table>

        <!-- 分页区域 -->
        <div class="pagination-wrapper">
          <StdPagination
            :total="total || 0"
            :page-size="searchForm.limit"
            :currentPage="searchForm.pageNo"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </template>
    </template>
  </StdPageContainer>
</template>
<script>
  import { StdPageContainer, StdPageTitle, StdNullPage, StdPagination } from '@vhcl/ui-console';
  import tableCellTooltip from '@/components/TableList/mixins/tableCellTooltip';
  export default {
    name: 'feedbackList',
    mixins: [tableCellTooltip],
    components: {
      StdPageContainer,
      StdPageTitle,
      StdNullPage,
      StdPagination
    },
    data() {
      return {
        list: [],
        total: 0,
        searchForm: {
          target_id: '',
          reporter_contact: '',
          reason_type: '',
          status: '',
          pageNo: 1,
          limit: 20
        },
        isSearch: false,
        reasonOptions: {},
        statusOptions: [
          { label: this.$t('lang.k_393021'), value: 1 },
          { label: this.$t('lang.k_393022'), value: 3 }
        ]
      };
    },
    created() {
      this.getFeedbackTypeList();
      this.checkSearchStatus();
      this.getTableList();
    },
    methods: {
      handleSearch() {
        this.searchForm.pageNo = 1;
        this.checkSearchStatus();
        this.getTableList();
      },
      handleCurrentChange(pageNo) {
        this.searchForm.pageNo = pageNo;
        this.checkSearchStatus();
        this.getTableList();
      },
      handleSizeChange(limit) {
        this.searchForm.limit = limit;
        this.searchForm.pageNo = 1;
        this.checkSearchStatus();
        this.getTableList();
      },
      checkSearchStatus() {
        // 检查是否有搜索条件
        this.isSearch = !!(
          this.searchForm.target_id ||
          this.searchForm.reason_type ||
          this.searchForm.status ||
          this.searchForm.reporter_contact
        );
      },
      getTableList() {
        const params = {
          target_id: this.searchForm.target_id,
          reporter_contact: this.searchForm.reporter_contact,
          reason_type: this.searchForm.reason_type,
          status: this.searchForm.status,
          pos: (this.searchForm.pageNo - 1) * this.searchForm.limit,
          limit: this.searchForm.limit
        };
        if (this.searchForm.target_id) {
          params.target_type = 1;
        }
        this.$fetch('getFeedbackList', params)
          .then(res => {
            if (res && res.code === 200) {
              this.list = res.data.list || [];
              this.total = res.data.total || 0;
            }
          })
          .catch(res => {
            this.$vhMessage.error(res?.msg);
          });
      },
      getFeedbackTypeList() {
        this.$fetch('getFeedbackTypeList').then(res => {
          if (res && res.code === 200) {
            this.reasonOptions = res?.data?.list || {};
          }
        });
      },
      getReasonLabel(reasonType) {
        return this.reasonOptions[reasonType] || '- -';
      },
      getStatusLabel(status) {
        const option = this.statusOptions.find(item => item.value === status);
        return option ? option.label : '- -';
      },
      handleViewDetail(row) {
        this.$vhMessage.info(this.$t('lang.k_393023'));
      },
      handleFeedback(row) {
        this.$fetch('handleFeedback', { id: row.id, status: row.status }).then(res => {
          if (res && res.code === 200) {
            this.$vhMessage.success(this.$t('lang.k_393024'));
            this.getTableList();
          } else {
            this.$vhMessage.error(res?.msg || this.$t('lang.k_393025'));
          }
        });
      },
      handleExport() {
        const params = {
          target_id: this.searchForm.target_id,
          reason_type: this.searchForm.reason_type,
          status: this.searchForm.status,
          pos: (this.searchForm.pageNo - 1) * this.searchForm.limit,
          limit: this.searchForm.limit
        };
        if (this.searchForm.target_id) {
          params.target_type = 1;
        }
        this.$fetch('exportFeedbackList', params)
          .then(res => {
            if (res && res.code === 200) {
              this.$vhMessage.success(this.$t('lang.k_393026'));
            }
          })
          .catch(res => {
            this.$vhMessage.error(res?.message || res.msg);
          });
      }
    }
  };
</script>
<style lang="less" scoped>
  .title_tips {
    font-size: 14px;
    color: #999;
    margin-left: 10px;
  }
  .null-data {
    min-height: calc(100vh - 240px);
    position: relative;
    background: #fff;
  }
  .search-area {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;

    .search-form {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .vh-form-item {
        margin-bottom: 0;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        &.button-group {
          margin-left: auto;
          margin-right: 0;

          .vh-button {
            margin-left: 10px;

            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .feedback-list {
    .activity-name,
    .description {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .vh-tag {
      font-size: 12px;
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .total-text {
      color: #666;
      font-size: 14px;
    }
  }
</style>
